import { Vendor } from '../store/models/models';

export const getVendorAddress = (vendorData: Vendor) => {
  if (!vendorData?.contactInfo) {
    return '';
  }

  let addressValue = `${vendorData.contactInfo?.street}, ${vendorData.contactInfo?.city}, `;

  if (vendorData.contactInfo?.state) {
    addressValue += `${vendorData.contactInfo?.state}, `;
  }

  if (vendorData.contactInfo?.zip) {
    addressValue += `${vendorData.contactInfo.country}, ${vendorData.contactInfo.zip}`;
  } else {
    addressValue += `${vendorData.contactInfo?.country}`;
  }

  return addressValue;
};
